module.exports = __webpack_public_path__ + "img/pull-request.79ec709f.png";